import {useEffect, useState} from "react";
import * as React from "react";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import PropTypes from "prop-types";
import {
  GetCountries,
  GetState,
  GetCity,
  GetLanguages,
  GetRegions,
  GetPhonecodes
} from "react-country-state-city";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import {
  Alert,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  Divider,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  TextField,
  FormHelperText
} from "@mui/material";
import MDButton from "components/MDButton";
import dayjs from "dayjs";
import {EmergencyRecording, Label} from "@mui/icons-material";
import {PATCH, GET} from "APIclient";
import Snackbar from "@mui/material/Snackbar";
import {useLocation} from "react-router-dom";
import properties from "constants/ApplicationConstants";

function EmployeeDetails() {
  const location = useLocation();
  const empId = location.state || window.sessionStorage.getItem("empId");
  const [region, setRegion] = useState("");
  const [countryid, setCountryid] = useState(0);
  const [stateid, setStateid] = useState(0);
  const [cityid, setCityid] = useState(0);
  const [language, setLanguage] = useState(0);
  const [phoneCode, setPhoneCode] = useState("");
  const [phonecodeList, setPhonecodeList] = useState([]);
  const [regionsList, setRegionsList] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [languageList, setLanguageList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      // GetPhonecodes().then(result => { setPhonecodeList(result); });
      // GetRegions().then(result => { setRegionsList(result); });
      // GetCountries().then(result => { setCountriesList(result); });
      // GetCity().then(result => { setCityList(result); console.log("city", result); });
    };
    fetchData();
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = React.useState({
    empId: empId,
    salutation: "",
    message: "",
    firstName: "",
    middleName: "",
    lastName: "",
    fatherName: "",
    motherName: "",
    gender: "",
    maritalStatus: "",
    birthDate: null,
    emailAddress: "",
    countryCodeMobile: "",
    mobileNo: "",
    alterMobileNo: "",
    education: "",
    educationOther: "",
    pfUanNo: "",
    prevPfNo: "",
    bntPfNo: "",
    speciallyAbled: "",
    speciallyAbledCategory: "",
    prevLastWorkingDate: null,
    joinDate: null,
    extension: "",
    bayArea: "",
    officeLocation: "",
    countryCodeEmergency: "",
    emergencyContact: "",
    nameRelation: "",
    emergencyRelation: "",
    emegencyAddressLine1: "",
    emergencyCity: "",
    emergencyState: "",
    emergencyPincode: ""
  });

  const [states, setStates] = React.useState([]);
  const [cities, setCities] = React.useState([]);
  const [countryCodeMob, setCountryCodeMob] = React.useState([]);
  const [countryCodeEmergency, setCountryCodeEmergency] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [newId, SetNewId] = React.useState();
  const [snakColor, setSnakColor] = React.useState("");
  const [snakMessage, setSnakMessage] = React.useState("");
  const [snackbar, setSnackbar] = React.useState(null);
  const [isEdited, setIsEdited] = useState(false);
  const [hasBankDetailsPermission, setHasBankDetailsPermission] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSnackbar = () => setSnackbar(null);

  const fetchStatesAndCities = async (country, stateValue) => {
    try {
      const url = `admin/location-list/${country || ""}`;
      const response = await GET(url);
      if (response?.status === 200) {
        const data = response?.data?.data || [];
        setStates(data);
        if (stateValue) {
          const selectedState = data.find(state => state?.state === stateValue) || {cities: []};
          setCities(selectedState.cities || []);
          console.log("Cities for selected state:", selectedState.cities || []);
        } else {
          setCities([]);
        }
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
      setStates([]);
      setCities([]);
      setSnakMessage("Failed to load states and cities. Please try again.");
      setSnakColor("error");
      setOpen(true);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const countryUrl = "admin/countries";
        const response = await GET(countryUrl);
        const data = response?.data?.data || [];
        if (data && response?.data?.statusCode === 200 && Array.isArray(data)) {
          setCountryCodeMob(data);
          setCountryCodeEmergency(data);
        } else {
          setSnakMessage("Failed to load countries. Please try again.");
          setSnakColor("error");
          setOpen(true);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        setCountryCodeMob([]);
        setCountryCodeEmergency([]);
        setSnakMessage("Failed to load countries. Please try again.");
        setSnakColor("error");
        setOpen(true);
      }
    };
    fetchCountries();
  }, []);

  const handleCountryCodeChange = e => {
    const selectedCountry = e.target.value || "";
    setFormData({...formData, countryCodeMobile: selectedCountry});
    setIsEdited(true);
  };

  const handleCountryChange = e => {
    const selectedCountry = e.target.value || "";
    setStates([]);
    setCities([]);
    setFormData({
      ...formData,
      countryCodeEmergency: selectedCountry,
      emergencyState: "",
      emergencyCity: ""
    });
    fetchStatesAndCities(selectedCountry, "");
    setIsEdited(true);
  };

  const handleStateChange = e => {
    const selectedState = e.target.value || "";
    setFormData({
      ...formData,
      emergencyState: selectedState,
      emergencyCity: ""
    });
    const stateData = states.find(state => state?.state === selectedState) || {cities: []};
    setCities(stateData.cities || []);
    validateField("emergencyState", selectedState);
    validateField("emergencyCity", "");
  };

  const handleCityChange = e => {
    const selectedCity = e.target.value || "";
    setFormData({...formData, emergencyCity: selectedCity});
    validateField("emergencyCity", selectedCity);
  };

  const [errors, setErrors] = useState({
    empId: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    mobileNo: "",
    education: "",
    salutation: "",
    fatherName: "",
    motherName: "",
    maritalStatus: "",
    birthDate: "",
    educationOther: "",
    speciallyAbled: "",
    speciallyAbledCategory: "",
    extension: "",
    bayArea: "",
    officeLocation: "",
    emergencyContact: "",
    emegencyAddressLine1: "",
    emergencyCity: "",
    emergencyState: "",
    emergencyPincode: "",
    alterMobileNo: "",
    nameRelation: "",
    emergencyRelation: "",
    countryCodeEmergency: ""
  });

  const validateField = (name, value) => {
    let errorMessage = "";
    if (name === "emergencyState" && (!value || value.toString().trim() === "")) {
      errorMessage = "State is required.";
    }
    if (name === "emergencyCity" && (!value || value.toString().trim() === "")) {
      errorMessage = "City is required.";
    }
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage
    }));
  };

  const fieldLabels = {
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    salutation: "Salutation",
    empId: "Employee ID",
    fatherName: "Father's Name",
    motherName: "Mother's Name",
    emailAddress: "Email Address",
    countryCodeMobile: "Country Code",
    mobileNo: "Mobile Number",
    alterMobileNo: "Alternate Mobile Number",
    education: "Education",
    educationOther: "Other Education",
    pfUanNo: "PF UAN Number",
    prevPfNo: "Previous PF Number",
    bntPfNo: "BNT PF Number",
    speciallyAbled: "Specially Abled",
    speciallyAbledCategory: "Specially Abled Category",
    extension: "Extension",
    bayArea: "Bay Area",
    officeLocation: "Office Location",
    countryCodeEmergency: "Country Code",
    emergencyContact: "Emergency Contact",
    emegencyAddressLine1: "Emergency Address Line 1",
    emergencyCity: "Emergency City",
    emergencyState: "Emergency State",
    emergencyPincode: "Emergency Pincode",
    nameRelation: "Name of the Person",
    emergencyRelation: "Relation"
  };

  const handleChange = e => {
    const {name, value} = e.target;
    let errorMessage = "";

    if (name === "salutation") {
      if (value === "Mr." || value === "") {
        setFormData(prevState => ({
          ...prevState,
          salutation: value,
          gender: "Male"
        }));
      } else if (value === "Mrs." || value === "Ms.") {
        setFormData(prevState => ({
          ...prevState,
          salutation: value,
          gender: "Female"
        }));
      } else {
        setFormData(prevState => ({
          ...prevState,
          salutation: value,
          gender: ""
        }));
      }
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value || ""
      }));
    }

    if (name === "empId") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Employee ID is required.";
      } else if (!/^\d+$/.test(value)) {
        errorMessage = "Employee ID should contain only numbers.";
      }
    } else if (name === "salutation") {
      const validSalutations = ["Mr.", "Mrs.", "Ms.", "Dr."];
      if (!value || value.toString().trim() === "") {
        errorMessage = "Salutation is required.";
      } else if (!validSalutations.includes(value)) {
        errorMessage = "Please select a valid salutation.";
      }
    } else if (name === "firstName" || name === "lastName" || name === "middleName") {
      if (!value || value.toString().trim() === "") {
        errorMessage = name === "middleName" ? "" : `${fieldLabels[name]} is required.`;
      } else if (/\d/.test(value)) {
        errorMessage = `${fieldLabels[name]} should not contain numbers.`;
      } else if (value.length > 20) {
        errorMessage = `${fieldLabels[name]} should not be longer than 20 characters.`;
      } else if (/[\W_]/.test(value)) {
        errorMessage = `${fieldLabels[name]} should not contain special characters.`;
      }
    } else if (name === "fatherName" || name === "motherName") {
      if (!value || value.toString().trim() === "") {
        errorMessage = `${fieldLabels[name]} is required.`;
      } else if (/\d/.test(value)) {
        errorMessage = `${fieldLabels[name]} should not contain numbers.`;
      } else if (value.length > 40) {
        errorMessage = `${fieldLabels[name]} should not be longer than 40 characters.`;
      } else if (/[^a-zA-Z\s]/.test(value)) {
        errorMessage = `${fieldLabels[name]} should not contain special characters `;
      }
    } else if (name === "maritalStatus") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Marital Status is required.";
      }
    } else if (name === "emailAddress") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || value.toString().trim() === "") {
        errorMessage = "Email is required.";
      } else if (!emailRegex.test(value)) {
        errorMessage = "Please enter a valid email address.";
      }
    } else if (name === "mobileNo") {
      const phoneRegex = /^[0-9]{10}$/;
      if (!value || value.toString().trim() === "") {
        errorMessage = "Mobile number is required.";
      } else if (!phoneRegex.test(value)) {
        errorMessage = "Please enter a valid 10-digit mobile number.";
      }
      if (
        value &&
        value === formData.alterMobileNo &&
        formData.alterMobileNo.toString().trim() !== ""
      ) {
        setErrors(prevErrors => ({
          ...prevErrors,
          alterMobileNo: "Alternate mobile number must be different from mobile number."
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          alterMobileNo: prevErrors.alterMobileNo.includes("different")
            ? ""
            : prevErrors.alterMobileNo
        }));
      }
    } else if (name === "alterMobileNo") {
      const phoneRegex = /^[0-9]{10}$/;
      if (value && value.toString().trim() !== "" && !phoneRegex.test(value)) {
        errorMessage = "Please enter a valid 10-digit mobile number.";
      } else if (
        value &&
        value === formData.mobileNo &&
        formData.mobileNo.toString().trim() !== ""
      ) {
        errorMessage = "Alternate mobile number must be different from mobile number.";
      }
    } else if (name === "education") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Education is required.";
      }
    } else if (name === "educationOther" || name === "education") {
      const educationOtherValue = formData?.educationOther || "";
      if (
        (formData?.education || "") === "Other" &&
        (!educationOtherValue || educationOtherValue.toString().trim() === "")
      ) {
        errorMessage = "Please specify the education for 'Other'.";
      }
    } else if (name === "speciallyAbled") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Specially Abled status is required.";
      }
    } else if (name === "speciallyAbledCategory") {
      if (
        (formData?.speciallyAbled || "") === "Yes" &&
        (!value || value.toString().trim() === "")
      ) {
        errorMessage = "Specially Abled Category is required when 'Yes' is selected.";
      }
    } else if (name === "extension") {
      const extensionRegex = /^[a-zA-Z0-9\s]*$/;
      if (!value || value.toString().trim() === "") {
        errorMessage = "";
      } else if (!extensionRegex.test(value)) {
        errorMessage = "Extension should only contain letters, numbers, and spaces.";
      }
    } else if (name === "bayArea") {
      const bayAreaRegex = /^[a-zA-Z0-9\s]*$/;
      if (!value || value.toString().trim() === "") {
        errorMessage = "";
      } else if (!bayAreaRegex.test(value)) {
        errorMessage = "Bay Area should only contain letters, numbers, and spaces.";
      }
    } else if (name === "officeLocation") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Office Location is required.";
      }
    } else if (name === "emergencyContact") {
      const phoneRegex = /^[0-9]{10}$/;
      if (!value || value.toString().trim() === "") {
        errorMessage = "Emergency Contact is required.";
      } else if (!phoneRegex.test(value)) {
        errorMessage = "Please enter a valid 10-digit phone number.";
      }
    } else if (name === "nameRelation") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Name of the person is required.";
      }
    } else if (name === "emergencyRelation") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Relation is required.";
      }
    } else if (name === "countryCodeEmergency") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Country Code is required.";
      }
    } else if (name === "emegencyAddressLine1") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "Address is required.";
      }
    } else if (name === "emergencyCity") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "City is required.";
      }
    } else if (name === "emergencyState") {
      if (!value || value.toString().trim() === "") {
        errorMessage = "State is required.";
      }
    } else if (name === "emergencyPincode") {
      const pincodeRegex = /^[0-9]{6}$/;
      if (!value || value.toString().trim() === "") {
        errorMessage = "Pincode is required.";
      } else if (!pincodeRegex.test(value)) {
        errorMessage = "Please enter a valid 6-digit Pincode.";
      }
    }

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage
    }));

    setIsEdited(true);
  };

  const handlePrevLastWorkingDate = newValue => {
    setFormData(prevFormData => ({
      ...prevFormData,
      prevLastWorkingDate: newValue ? newValue.format("YYYY-MM-DD") : null
    }));
  };

  const handleDateOfBirthChange = newValue => {
    setFormData(prevFormData => ({
      ...prevFormData,
      birthDate: newValue ? newValue.format("YYYY-MM-DD") : null
    }));
  };

  const handleDateChange = (date, field) => {
    const validDate = date ? dayjs(date) : null;
    let errorMessage = "";

    if (field === "birthDate") {
      if (!validDate || !validDate.isValid()) {
        errorMessage = "Date of birth is required.";
      } else if (validDate.isAfter(dayjs(), "day") || validDate.isSame(dayjs(), "day")) {
        errorMessage = "Date of birth cannot be today or after date.";
      }
    }

    setFormData(prev => ({
      ...prev,
      [field]: validDate?.isValid() ? validDate.format("YYYY-MM-DD") : null
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [field]: errorMessage
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    const requiredFields = [
      "empId",
      "salutation",
      "firstName",
      "lastName",
      "fatherName",
      "motherName",
      "gender",
      "maritalStatus",
      "birthDate",
      "emailAddress",
      "countryCodeMobile",
      "mobileNo",
      "education",
      "officeLocation",
      "nameRelation",
      "emergencyContact",
      "emergencyRelation",
      "emegencyAddressLine1",
      "countryCodeEmergency",
      "emergencyState",
      "emergencyCity",
      "emergencyPincode"
    ];

    requiredFields.forEach(field => {
      const value = formData[field];
      let errorMessage = "";

      // Handle date fields separately
      if (field === "birthDate") {
        const validDate = value ? dayjs(value) : null;
        if (!validDate || !validDate.isValid()) {
          errorMessage = "Date of birth is required.";
          isValid = false;
        } else if (validDate.isAfter(dayjs(), "day") || validDate.isSame(dayjs(), "day")) {
          errorMessage = "Date of birth cannot be today or in the future.";
          isValid = false;
        }
      } else {
        const stringValue = value == null ? "" : value.toString();
        if (field === "empId") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Employee ID is required.";
            isValid = false;
          } else if (!/^\d+$/.test(stringValue)) {
            errorMessage = "Employee ID should contain only numbers.";
            isValid = false;
          }
        } else if (field === "salutation") {
          const validSalutations = ["Mr.", "Mrs.", "Ms.", "Dr."];
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Salutation is required.";
            isValid = false;
          } else if (!validSalutations.includes(stringValue)) {
            errorMessage = "Please select a valid salutation.";
            isValid = false;
          }
        } else if (field === "firstName" || field === "lastName") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = `${fieldLabels[field]} is required.`;
            isValid = false;
          } else if (/\d/.test(stringValue)) {
            errorMessage = `${fieldLabels[field]} should not contain numbers.`;
            isValid = false;
          } else if (stringValue.length > 20) {
            errorMessage = `${fieldLabels[field]} should not be longer than 20 characters.`;
            isValid = false;
          } else if (/[\W_]/.test(stringValue)) {
            errorMessage = `${fieldLabels[field]} should not contain special characters.`;
            isValid = false;
          }
        } else if (field === "fatherName" || field === "motherName") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = `${fieldLabels[field]} is required.`;
            isValid = false;
          } else if (/\d/.test(stringValue)) {
            errorMessage = `${fieldLabels[field]} should not contain numbers.`;
            isValid = false;
          } else if (stringValue.length > 40) {
            errorMessage = `${fieldLabels[field]} should not be longer than 40 characters.`;
            isValid = false;
          } else if (/[^a-zA-Z\s]/.test(stringValue)) {
            errorMessage = `${fieldLabels[field]} should not contain special characters.`;
            isValid = false;
          }
        } else if (field === "middleName") {
          if (stringValue && stringValue.trim() !== "") {
            if (/\d/.test(stringValue)) {
              errorMessage = `${fieldLabels[field]} should not contain numbers.`;
              isValid = false;
            } else if (stringValue.length > 20) {
              errorMessage = `${fieldLabels[field]} should not be longer than 20 characters.`;
              isValid = false;
            } else if (/[\W_]/.test(stringValue)) {
              errorMessage = `${fieldLabels[field]} should not contain special characters.`;
              isValid = false;
            }
          }
        } else if (field === "gender") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Gender is required.";
            isValid = false;
          }
        } else if (field === "maritalStatus") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Marital Status is required.";
            isValid = false;
          }
        } else if (field === "emailAddress") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Email is required.";
            isValid = false;
          } else if (!emailRegex.test(stringValue)) {
            errorMessage = "Please enter a valid email address.";
            isValid = false;
          }
        } else if (field === "countryCodeMobile") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Country Code is required.";
            isValid = false;
          }
        } else if (field === "mobileNo") {
          const phoneRegex = /^[0-9]{10}$/;
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Mobile number is required.";
            isValid = false;
          } else if (!phoneRegex.test(stringValue)) {
            errorMessage = "Please enter a valid 10-digit mobile number.";
            isValid = false;
          } else if (
            stringValue &&
            stringValue === formData.alterMobileNo &&
            formData.alterMobileNo.toString().trim() !== ""
          ) {
            newErrors.alterMobileNo =
              "Alternate mobile number must be different from mobile number.";
            isValid = false;
          }
        } else if (field === "alterMobileNo") {
          const phoneRegex = /^[0-9]{10}$/;
          if (stringValue && stringValue.trim() !== "" && !phoneRegex.test(stringValue)) {
            errorMessage = "Please enter a valid 10-digit mobile number.";
            isValid = false;
          } else if (
            stringValue &&
            stringValue === formData.mobileNo &&
            formData.mobileNo.toString().trim() !== ""
          ) {
            errorMessage = "Alternate mobile number must be different from mobile number.";
            isValid = false;
          }
        } else if (field === "education") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Education is required.";
            isValid = false;
          }
        } else if (field === "officeLocation") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Office Location is required.";
            isValid = false;
          }
        } else if (field === "nameRelation") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Name of the person is required.";
            isValid = false;
          }
        } else if (field === "emergencyContact") {
          const phoneRegex = /^[0-9]{10}$/;
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Emergency Contact is required.";
            isValid = false;
          } else if (!phoneRegex.test(stringValue)) {
            errorMessage = "Please enter a valid 10-digit phone number.";
            isValid = false;
          }
        } else if (field === "emergencyRelation") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Relation is required.";
            isValid = false;
          }
        } else if (field === "emegencyAddressLine1") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Address is required.";
            isValid = false;
          }
        } else if (field === "countryCodeEmergency") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Country Code is required.";
            isValid = false;
          }
        } else if (field === "emergencyState") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "State is required.";
            isValid = false;
          }
        } else if (field === "emergencyCity") {
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "City is required.";
            isValid = false;
          }
        } else if (field === "emergencyPincode") {
          const pincodeRegex = /^[0-9]{6}$/;
          if (!stringValue || stringValue.trim() === "") {
            errorMessage = "Pincode is required.";
            isValid = false;
          } else if (!pincodeRegex.test(stringValue)) {
            errorMessage = "Please enter a valid 6-digit Pincode.";
            isValid = false;
          }
        }

        newErrors[field] = errorMessage;
      }
    });

    if (formData.education === "Other") {
      const educationOtherValue =
        formData.educationOther == null ? "" : formData.educationOther.toString();
      if (!educationOtherValue || educationOtherValue.trim() === "") {
        newErrors.educationOther = "Please specify the education for 'Other'.";
        isValid = false;
      }
    }

    if (formData.speciallyAbled === "Yes") {
      const speciallyAbledCategoryValue =
        formData.speciallyAbledCategory == null ? "" : formData.speciallyAbledCategory.toString();
      if (!speciallyAbledCategoryValue || speciallyAbledCategoryValue.trim() === "") {
        newErrors.speciallyAbledCategory =
          "Specially Abled Category is required when 'Yes' is selected.";
        isValid = false;
      }
    }

    setErrors(prevErrors => ({
      ...prevErrors,
      ...newErrors
    }));

    return isValid;
  };

  const handleSubmit = async () => {
    if (!hasBankDetailsPermission) {
      setSnakMessage("You do not have permission to save details.");
      setSnakColor("error");
      setOpen(true);
      return;
    }

    const isValid = validateForm();

    if (!isValid) {
      setSnakMessage("Please fill all required fields correctly.");
      setSnakColor("error");
      setOpen(true);
      return;
    }

    const url = `employee/details`;
    try {
      let response = await PATCH(url, formData);
      response = response?.data || {};

      if (response?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage(response?.message || "Data saved successfully");
        setOpen(true);
        setIsEdited(false);
      }

      localStorage.setItem("Employee_Details", JSON.stringify(response));
    } catch (error) {
      setSnakMessage(error.response?.data?.message || "Failed to save employee details.");
      setSnakColor("error");
      setOpen(true);
    }
  };

  const normalizeSalutation = salutation => {
    const salutationMap = {
      "Mr.": "Mr.",
      "Mrs.": "Mrs.",
      "Ms.": "Ms.",
      mr: "Mr.",
      mrs: "Mrs.",
      ms: "Ms."
    };
    return salutationMap[salutation] || salutationMap[salutation?.toLowerCase()] || "";
  };

  useEffect(() => {
    const fetchData = async () => {
      let data = {};
      try {
        let response = await GET(`employee/employee-details/${empId}`);
        console.log("response", response ? response.data : []);
        data = response?.data?.data || response;

        if (data && response?.data?.statusCode === 200) {
          const employeeData = data?.employee || {};
          setFormData(prevFormData => ({
            ...prevFormData,
            ...employeeData,
            gender: employeeData?.gender
              ? employeeData.gender.charAt(0).toUpperCase() +
                employeeData.gender.slice(1).toLowerCase()
              : "",
            salutation: normalizeSalutation(employeeData?.salutation),
            maritalStatus: employeeData?.maritalStatus?.toLowerCase() || "",
            speciallyAbled:
              employeeData?.speciallyAbled === "1" || employeeData?.speciallyAbled === "Yes"
                ? "Yes"
                : employeeData?.speciallyAbled === "0" || employeeData?.speciallyAbled === "No"
                ? "No"
                : "",
            speciallyAbledCategory:
              employeeData?.speciallyAbledCategory === "0" ||
              employeeData?.speciallyAbledCategory === "No"
                ? "No"
                : employeeData?.speciallyAbledCategory || "",
            educationOther:
              employeeData.educationOther && employeeData.educationOther !== "0"
                ? employeeData.educationOther
                : "",
            countryCodeEmergency: employeeData?.countryCodeEmergency || "",
            emergencyState: employeeData?.emergencyState || "",
            emergencyCity: employeeData?.emergencyCity || ""
          }));
          if (employeeData?.countryCodeEmergency) {
            fetchStatesAndCities(employeeData?.countryCodeEmergency, employeeData?.emergencyState);
          }
          setHasBankDetailsPermission(employeeData?.permissions.includes("details"));
          console.log("testdata", data.employee || {});
        } else {
          console.log(response?.message || "No response message");
        }
      } catch (error) {
        console.error("Error adding data:", error);
        setSnakMessage("Failed to load employee details. Please try again.");
        setSnakColor("error");
        setOpen(true);
      }
    };
    fetchData();
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  if (isLoading) {
    return (
      <div
        style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <MDBox>
      <MDBox pt={4} pb={3} px={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <MDInput
              pattern="\d*"
              min={0}
              sx={{m: 1, width: "25ch"}}
              name="empId"
              value={window.sessionStorage.getItem("empId") || empId}
              type="text"
              label={
                <span>
                  Employee ID<span style={{color: properties.colors.Red}}>*</span>
                </span>
              }
              variant="standard"
              onChange={e => handleChange(e)}
              error={!!errors.empId}
              helperText={errors.empId}
              disabled
            />
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl sx={{m: 1, pt: 1, width: "10ch"}} variant="standard">
                <InputLabel>
                  Mr./Mrs.<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  name="salutation"
                  value={formData?.salutation || ""}
                  onChange={e => handleChange(e)}
                  error={!!errors.salutation}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="Mr.">Mr.</MenuItem>
                  <MenuItem value="Mrs.">Mrs.</MenuItem>
                  <MenuItem value="Ms.">Ms.</MenuItem>
                </Select>
                {errors.salutation && <FormHelperText error>{errors.salutation}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <MDInput
                sx={{m: 1, width: "20ch"}}
                name="firstName"
                value={formData?.firstName || ""}
                type="text"
                label={
                  <span>
                    First Name<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                variant="standard"
                onChange={e => handleChange(e)}
                error={!!errors.firstName}
                helperText={errors.firstName}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
            <Grid item>
              <MDInput
                sx={{m: 1, width: "20ch"}}
                name="middleName"
                value={formData?.middleName || ""}
                type="text"
                label="Middle Name"
                variant="standard"
                onChange={e => handleChange(e)}
                error={!!errors?.middleName}
                helperText={errors?.middleName}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
            <Grid item>
              <MDInput
                sx={{m: 1, width: "20ch"}}
                name="lastName"
                value={formData?.lastName || ""}
                type="text"
                label={
                  <span>
                    Last Name<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                variant="standard"
                onChange={e => handleChange(e)}
                error={!!errors?.lastName}
                helperText={errors?.lastName}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <MDInput
                sx={{m: 1, width: "33ch"}}
                type="text"
                name="fatherName"
                label={
                  <span>
                    Father Name<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                value={formData?.fatherName || ""}
                variant="standard"
                onChange={e => handleChange(e)}
                fullWidth
                error={!!errors?.fatherName}
                helperText={errors?.fatherName}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
            <Grid item>
              <MDInput
                sx={{m: 1, width: "30ch"}}
                type="text"
                name="motherName"
                label={
                  <span>
                    Mother Name<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                value={formData?.motherName || ""}
                variant="standard"
                onChange={e => handleChange(e)}
                fullWidth
                error={!!errors?.motherName}
                helperText={errors?.motherName}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, width: "33ch"}}>
                <InputLabel id="gender">
                  Gender<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  labelId="gender"
                  id="gender"
                  value={formData?.gender || ""}
                  name="gender"
                  label="Gender"
                  onChange={e => handleChange(e)}
                  error={!!errors.gender}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </Select>
                {errors.gender && <FormHelperText error>{errors.gender}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                <InputLabel id="maritalStatus">
                  Marital Status<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  labelId="maritalStatus"
                  id="maritalStatus"
                  value={formData?.maritalStatus || ""}
                  name="maritalStatus"
                  onChange={e => handleChange(e)}
                  label="Marital Status"
                  error={!!errors.maritalStatus}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="married">Married</MenuItem>
                  <MenuItem value="unmarried">Un-Married</MenuItem>
                </Select>
                {errors.maritalStatus && (
                  <FormHelperText error>{errors.maritalStatus}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <MDBox m={1}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      sx={{m: 1, width: "34ch"}}
                      size="small"
                      label={
                        <span>
                          DOB<span style={{color: properties.colors.Red}}>*</span>
                        </span>
                      }
                      name="birthDate"
                      value={
                        formData?.birthDate && dayjs(formData.birthDate).isValid()
                          ? dayjs(formData.birthDate)
                          : null
                      }
                      onChange={date => handleDateChange(date, "birthDate")}
                      slotProps={{
                        textField: {
                          error: !!errors.birthDate,
                          helperText: errors.birthDate || "",
                          variant: "standard"
                        }
                      }}
                      readOnly={!hasBankDetailsPermission}
                    />
                    {errors.birthDate && <FormHelperText error>{errors.birthDate}</FormHelperText>}
                  </MDBox>
                  <MDInput
                    type="email"
                    name="emailAddress"
                    value={formData?.emailAddress || ""}
                    inputProps={{pattern: "/^[w-.]+@([w-]+.)+[w-]{2,4}$/g"}}
                    id="outlined-error"
                    onChange={e => handleChange(e)}
                    label="Email"
                    variant="standard"
                    sx={{m: 1, width: "30ch"}}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    disabled={!hasBankDetailsPermission}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, pt: 1, width: "33ch"}}>
                <InputLabel>
                  Country<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  name="countryCodeMobile"
                  value={formData?.countryCodeMobile || ""}
                  onChange={handleCountryCodeChange}
                  label="Country Code"
                  error={!!errors.countryCodeMobile}
                  readOnly={!hasBankDetailsPermission}
                >
                  {countryCodeMob && countryCodeMob.length > 0 ? (
                    countryCodeMob.map(country => (
                      <MenuItem key={country?.countryId || ""} value={country?.countryCode || ""}>
                        {country?.countryName || ""} ({country?.countryCode || ""})
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No countries available</MenuItem>
                  )}
                </Select>
                {errors.countryCodeMobile && (
                  <FormHelperText error>{errors.countryCodeMobile}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item>
              <MDInput
                type="text"
                name="mobileNo"
                label={
                  <span>
                    Mobile<span style={{color: properties.colors.Red}}>*</span>
                  </span>
                }
                value={formData?.mobileNo || ""}
                onChange={e => handleChange(e)}
                variant="standard"
                sx={{m: 1, width: "20ch"}}
                error={!!errors.mobileNo}
                helperText={errors.mobileNo}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
            <Grid item>
              <MDInput
                type="text"
                name="alterMobileNo"
                label="Alternate Mobile"
                value={formData?.alterMobileNo || ""}
                onChange={e => handleChange(e)}
                variant="standard"
                sx={{m: 1, width: "20ch"}}
                error={!!errors.alterMobileNo}
                helperText={errors.alterMobileNo}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, pt: 1, width: "33ch"}}>
                <InputLabel id="demo-simple-select-standard-label">
                  Education<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={formData?.education || ""}
                  name="education"
                  onChange={e => handleChange(e)}
                  label="Education*"
                  error={!!errors.education}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="SSC">SSC (Secondary School Certificate / 10th)</MenuItem>
                  <MenuItem value="HSC">HSC (Higher Secondary Certificate / 12th)</MenuItem>
                  <MenuItem value="Diploma">Diploma (Polytechnic / Technical Diploma)</MenuItem>
                  <MenuItem value="BCA">BCA (Bachelor of Computer Applications)</MenuItem>
                  <MenuItem value="BSc">
                    B.Sc. (Bachelor of Science in IT / CS / Electronics / Maths / Other)
                  </MenuItem>
                  <MenuItem value="BCom">B.Com (Bachelor of Commerce)</MenuItem>
                  <MenuItem value="BBA">BBA (Bachelor of Business Administration)</MenuItem>
                  <MenuItem value="BTech">B.Tech (Bachelor of Technology)</MenuItem>
                  <MenuItem value="BE">B.E. (Bachelor of Engineering)</MenuItem>
                  <MenuItem value="MCA">MCA (Master of Computer Applications)</MenuItem>
                  <MenuItem value="MSc">
                    M.Sc. (Master of Science in IT / CS / Maths / Other)
                  </MenuItem>
                  <MenuItem value="MTech">M.Tech (Master of Technology)</MenuItem>
                  <MenuItem value="ME">M.E. (Master of Engineering)</MenuItem>
                  <MenuItem value="MBA">MBA (Master of Business Administration)</MenuItem>
                  <MenuItem value="PGDM">PGDM (Post Graduate Diploma in Management)</MenuItem>
                  <MenuItem value="MCom">M.Com (Master of Commerce)</MenuItem>
                  <MenuItem value="PhD">PhD (Doctor of Philosophy)</MenuItem>
                  <MenuItem value="Other">Other (Please Specify)</MenuItem>
                </Select>
                {errors.education && <FormHelperText error>{errors.education}</FormHelperText>}
              </FormControl>
              {(formData?.education || "") === "Other" && (
                <MDInput
                  type="text"
                  name="educationOther"
                  value={formData?.educationOther || ""}
                  onChange={e => handleChange(e)}
                  label="Other"
                  variant="standard"
                  sx={{m: 1, width: "30ch"}}
                  error={!!errors.educationOther}
                  helperText={errors.educationOther}
                  disabled={!hasBankDetailsPermission}
                />
              )}
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <MDInput
                type="text"
                name="pfUanNo"
                label="UAN"
                value={formData?.pfUanNo || ""}
                onChange={e => handleChange(e)}
                variant="standard"
                sx={{m: 1, width: "33ch"}}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <MDInput
                type="text"
                name="prevPfNo"
                value={formData?.prevPfNo || ""}
                onChange={e => handleChange(e)}
                label="Prev PF No."
                variant="standard"
                sx={{m: 1, width: "33ch"}}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
            <Grid item>
              <MDInput
                type="text"
                name="bntPfNo"
                value={formData?.bntPfNo || ""}
                onChange={e => handleChange(e)}
                label="BNT PF No."
                variant="standard"
                sx={{m: 1, width: "30ch"}}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, width: "33ch"}}>
                <InputLabel id="speciallyAbled">
                  Specially Abled<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  labelId="speciallyAbled"
                  id="speciallyAbled"
                  name="speciallyAbled"
                  value={formData?.speciallyAbled || ""}
                  onChange={e => handleChange(e)}
                  label="Specially Abled"
                  error={!!errors.speciallyAbled}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
                {errors.speciallyAbled && (
                  <FormHelperText error>{errors.speciallyAbled}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                <InputLabel id="speciallyAbledCategory">Specially Abled Category</InputLabel>
                <Select
                  labelId="speciallyAbledCategory"
                  id="speciallyAbledCategory"
                  value={formData?.speciallyAbledCategory || ""}
                  name="speciallyAbledCategory"
                  onChange={e => handleChange(e)}
                  label="Specially Abled Category"
                  error={!!errors.speciallyAbledCategory}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  <MenuItem value="No">No</MenuItem>
                  <MenuItem value="Locomotive">Locomotive</MenuItem>
                  <MenuItem value="Visual">Visual</MenuItem>
                  <MenuItem value="Hearing">Hearing</MenuItem>
                </Select>
                {errors.speciallyAbledCategory && (
                  <FormHelperText error>{errors.speciallyAbledCategory}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    sx={{m: 1, width: "34ch"}}
                    size="small"
                    name="prevLastWorkingDate"
                    label="Prev. Employment Last Date"
                    value={
                      formData?.prevLastWorkingDate && dayjs(formData.prevLastWorkingDate).isValid()
                        ? dayjs(formData.prevLastWorkingDate)
                        : null
                    }
                    onChange={date => handleDateChange(date, "prevLastWorkingDate")}
                    readOnly={!hasBankDetailsPermission}
                  />
                  <DatePicker
                    sx={{m: 1, width: "30ch"}}
                    size="small"
                    label="Join Date"
                    name="joinDate"
                    value={
                      formData?.joinDate && dayjs(formData.joinDate).isValid()
                        ? dayjs(formData.joinDate)
                        : null
                    }
                    onChange={date => handleDateChange(date, "joinDate")}
                    readOnly={!hasBankDetailsPermission}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <MDInput
                type="text"
                name="extension"
                value={formData?.extension || ""}
                onChange={e => handleChange(e)}
                label="Extension"
                variant="standard"
                sx={{m: 1, width: "33ch"}}
                error={!!errors.extension}
                helperText={errors.extension}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
            <Grid item>
              <MDInput
                type="text"
                name="bayArea"
                value={formData?.bayArea || ""}
                onChange={e => handleChange(e)}
                label="Bay Area"
                variant="standard"
                sx={{m: 1, width: "30ch"}}
                error={!!errors.bayArea}
                helperText={errors.bayArea}
                disabled={!hasBankDetailsPermission}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="standard" sx={{m: 1, width: "33ch"}}>
                <InputLabel id="officeLocation">
                  Office Location<span style={{color: properties.colors.Red}}>*</span>
                </InputLabel>
                <Select
                  labelId="officeLocation"
                  id="officeLocation"
                  value={formData?.officeLocation || ""}
                  name="officeLocation"
                  onChange={e => handleChange(e)}
                  label="Office Location*"
                  error={!!errors.officeLocation}
                  readOnly={!hasBankDetailsPermission}
                >
                  <MenuItem value="">
                    <em>Select Location</em>
                  </MenuItem>
                  <MenuItem value="India">India</MenuItem>
                  <MenuItem value="US">US</MenuItem>
                </Select>
                {errors.officeLocation && (
                  <FormHelperText error>{errors.officeLocation}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Divider />
        <Card>
          <MDBox
            variant="gradient"
            sx={{background: properties.colors.bgcolorbluethem}}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={1}
            mb={1}
            textAlign="center"
          >
            <Typography
              variant="h6"
              color="#fff"
              fontWeight="medium"
              fontFamily={properties.fontFamily}
              mt={1}
            >
              Emergency Contact
            </Typography>
          </MDBox>
          <MDBox pt={2} pb={3} px={3}>
            <MDBox component="form" role="form">
              <MDBox mb={1} mr={3}>
                <MDInput
                  sx={{m: 1, width: "35ch"}}
                  name="nameRelation"
                  value={formData?.nameRelation || ""}
                  onChange={e => handleChange(e)}
                  type="text"
                  label={
                    <span>
                      Name of the person<span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  error={!!errors.nameRelation}
                  helperText={errors.nameRelation}
                  disabled={!hasBankDetailsPermission}
                />
                <MDInput
                  sx={{m: 1, width: "35ch"}}
                  name="emergencyContact"
                  value={formData?.emergencyContact || ""}
                  onChange={e => handleChange(e)}
                  type="text"
                  label={
                    <span>
                      Contact No.<span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  error={!!errors.emergencyContact}
                  helperText={errors.emergencyContact}
                  disabled={!hasBankDetailsPermission}
                />
              </MDBox>
              <MDBox display="flex" mb={1}>
                <MDBox mr={3}>
                  <FormControl variant="standard" sx={{m: 1, width: "35ch"}}>
                    <InputLabel id="emergencyRelation">
                      Relation<span style={{color: properties.colors.Red}}>*</span>
                    </InputLabel>
                    <Select
                      labelId="emergencyRelation"
                      id="emergencyRelation"
                      value={formData?.emergencyRelation || ""}
                      name="emergencyRelation"
                      onChange={e => handleChange(e)}
                      label="Relation *"
                      error={!!errors.emergencyRelation}
                      readOnly={!hasBankDetailsPermission}
                    >
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      <MenuItem value="father">Father</MenuItem>
                      <MenuItem value="mother">Mother</MenuItem>
                      <MenuItem value="son">Son</MenuItem>
                      <MenuItem value="daughter">Daughter</MenuItem>
                      <MenuItem value="spouse">Spouse</MenuItem>
                      <MenuItem value="brother">Brother</MenuItem>
                      <MenuItem value="sister">Sister</MenuItem>
                    </Select>
                    {errors.emergencyRelation && (
                      <FormHelperText error>{errors.emergencyRelation}</FormHelperText>
                    )}
                  </FormControl>
                </MDBox>
                <MDBox>
                  <MDInput
                    fullWidth
                    type="text"
                    sx={{width: "35ch"}}
                    name="emegencyAddressLine1"
                    value={formData?.emegencyAddressLine1 || ""}
                    onChange={e => handleChange(e)}
                    label={
                      <span>
                        Address<span style={{color: properties.colors.Red}}>*</span>
                      </span>
                    }
                    variant="standard"
                    error={!!errors.emegencyAddressLine1}
                    helperText={errors.emegencyAddressLine1}
                    disabled={!hasBankDetailsPermission}
                  />
                </MDBox>
              </MDBox>

              <MDBox mb={1} mr={3}>
                <FormControl variant="standard" sx={{m: 1, width: "10ch"}}>
                  <InputLabel>
                    Country<span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    name="countryCodeEmergency"
                    value={formData?.countryCodeEmergency || ""}
                    onChange={handleCountryChange}
                    label="Country Code"
                    error={!!errors.countryCodeEmergency}
                    readOnly={!hasBankDetailsPermission}
                  >
                    {countryCodeEmergency && countryCodeEmergency.length > 0 ? (
                      countryCodeEmergency.map(country => (
                        <MenuItem key={country?.countryId || ""} value={country?.countryCode || ""}>
                          {country?.countryName || ""} ({country?.countryCode || ""})
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No countries available</MenuItem>
                    )}
                  </Select>
                  {errors.countryCodeEmergency && (
                    <FormHelperText error>{errors.countryCodeEmergency}</FormHelperText>
                  )}
                </FormControl>
                <FormControl variant="standard" sx={{m: 1, width: "23ch"}}>
                  <InputLabel id="emergencyState">
                    State<span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    labelId="emergencyState"
                    id="emergencyState"
                    value={formData?.emergencyState || ""}
                    name="emergencyState"
                    label="State"
                    onChange={handleStateChange}
                    error={!!errors.emergencyState}
                    disabled={!formData?.countryCodeEmergency}
                    readOnly={!hasBankDetailsPermission}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {(states || []).map((state, index) => (
                      <MenuItem key={index} value={state?.state || ""}>
                        {state?.state || ""}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.emergencyState && (
                    <FormHelperText error>{errors.emergencyState}</FormHelperText>
                  )}
                </FormControl>
                <FormControl variant="standard" sx={{m: 1, width: "20ch"}}>
                  <InputLabel id="emergencyCity">
                    City<span style={{color: properties.colors.Red}}>*</span>
                  </InputLabel>
                  <Select
                    labelId="emergencyCity"
                    id="emergencyCity"
                    label="City"
                    name="emergencyCity"
                    onChange={handleCityChange}
                    value={formData?.emergencyCity || ""}
                    error={!!errors.emergencyCity}
                    disabled={!formData?.emergencyState}
                    readOnly={!hasBankDetailsPermission}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {(cities || []).map((city, index) => (
                      <MenuItem key={index} value={city || ""}>
                        {city || ""}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.emergencyCity && (
                    <FormHelperText error>{errors.emergencyCity}</FormHelperText>
                  )}
                </FormControl>
                <MDInput
                  sx={{width: "15ch"}}
                  type="text"
                  onChange={e => handleChange(e)}
                  value={formData?.emergencyPincode || ""}
                  name="emergencyPincode"
                  label={
                    <span>
                      Pincode<span style={{color: properties.colors.Red}}>*</span>
                    </span>
                  }
                  variant="standard"
                  error={!!errors.emergencyPincode}
                  helperText={errors.emergencyPincode}
                  disabled={!hasBankDetailsPermission}
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
        <Snackbar
          open={open}
          anchorOrigin={{vertical: "top", horizontal: "right"}}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={snakColor === "success" ? "success" : "error"}
            variant="filled"
            sx={{width: "100%", color: "#fff"}}
          >
            {snakMessage || "An error occurred"}
          </Alert>
        </Snackbar>
        <MDBox mt={3} mb={1} sx={{display: "grid", gridAutoColumns: "1fr", gap: 1}}>
          <MDBox sx={{gridRow: "1", gridColumn: "4 / 5"}}>
            <MDButton
              variant="gradient"
              color="info"
              sx={{width: "30ch", background: properties.colors.bgcolorbluethem}}
              onClick={() => handleSubmit()}
              disabled={!hasBankDetailsPermission || !isEdited}
            >
              SAVE
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

export default EmployeeDetails;
